<template>
  <div class="no-product-content" data-test-no-offer>
    <div class="no-product-content__msg-block">
      <div class="no-product-content__no-offer-main-message">
        <slot name="info"></slot>
      </div>
      <p>
        <slot name="detail"></slot>
      </p>
    </div>
    <div class="no-product-content__btn-block" v-if="isFrontAgri">
      <p-product-info-request-btn :product="product" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import PProductInfoRequestBtn from '@b2ag/offers/src/presenters/PProductInfoRequestBtn/PProductInfoRequestBtn.vue'
import type { Product } from './typings'

export default defineComponent({
  name: 'PNoProductContent',
  props: {
    showTechnicalSalesContact: {
      type: Boolean,
      default: true,
    },
    isFrontAgri: {
      type: Boolean,
      default: true,
    },
    product: {
      type: Object as PropType<Product>,
      default: () => ({}),
    },
  },
  components: {
    PProductInfoRequestBtn,
  },
})
</script>

<style scoped lang="scss">
.no-product-content {
  display: flex;
  flex-direction: column;
  padding-top: var(--spacing-3);

  @media (min-width: $breakpoint-md) {
    max-width: 40.8rem;
  }
}

.no-product-content__msg-block {
  flex-basis: 60%;
  margin-bottom: 15px;
  font-size: 16px;
  line-height: normal;

  @media (width <= 768px) {
    flex-basis: 100%;
  }
}

.no-product-content__btn-block {
  flex-basis: 30%;
  display: flex;
  align-items: center;

  @media (width <= 768px) {
    flex-basis: 100%;
  }
}

.no-product-content__no-offer-main-message {
  font-size: var(--font-size-l);
  margin-bottom: 0.5em;
  display: flex;
  line-height: var(--line-height-m);
  font-weight: bold;
}

.no-product-content__no-offer-sale-contact {
  margin-top: 1em;
  width: 100%;
}
</style>
